<template>
    <div>
        <v-text-field
                v-model="formData.website"
                class="mb-3"
                label="Website"
                hint="Must be a full URL e.g. https://www.mywebsite.com"
                :persistent-hint="true"
                :error-messages="websiteErrors"
                @input="$v.formData.website.$touch()"
                @blur="$v.formData.website.$touch()"
        ></v-text-field>
        <v-text-field
                v-model="formData.twitter"
                class="mb-3"
                label="Twitter"
                hint="Must be a full twitter URL e.g. https://twitter.com/mycompany"
                :persistent-hint="true"
                :error-messages="twitterErrors"
                @input="$v.formData.twitter.$touch()"
                @blur="$v.formData.twitter.$touch()"
        ></v-text-field>
        <v-text-field
                v-model="formData.facebook"
                class="mb-3"
                label="Facebook"
                hint="Must be a full facebook URL e.g. https://facebook.com/mycompany"
                :persistent-hint="true"
                :error-messages="facebookErrors"
                @input="$v.formData.facebook.$touch()"
                @blur="$v.formData.facebook.$touch()"
        ></v-text-field>
    </div>
</template>

<script>
  import {FieldsMixin} from '@/forms/mixins'
  import {url} from 'vuelidate/lib/validators'

  export default {
    name: 'SocialMediaFields',
    mixins: [FieldsMixin],
    data: () => ({
      formData: {
        website: null,
        twitter: null,
        facebook: null,
      }
    }),
    validations: {
      formData: {
        // TODO: validate twitter handle
        // TODO: validate facebook link
        // TODO: validate website url
        website: {
          url
        },
        twitter: {
          url
        },
        facebook: {
          url
        }
      }
    },
    computed: {
      websiteErrors () {
        const errors = []
        if (!this.$v.formData.website.$dirty) return errors
        !this.$v.formData.website.url && errors.push('Must be a full URL e.g. https://www.mywebsite.com')
        return errors
      },
      twitterErrors () {
        const errors = []
        if (!this.$v.formData.twitter.$dirty) return errors
        !this.$v.formData.twitter.url && errors.push('Must be a full twitter URL e.g. https://twitter.com/mycompany')
        return errors
      },
      facebookErrors () {
        const errors = []
        if (!this.$v.formData.facebook.$dirty) return errors
        !this.$v.formData.facebook.url && errors.push('Must be a full facebook URL e.g. https://facebook.com/mycompany')
        return errors
      }
    }
  }
</script>

<style scoped>

</style>
